import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderInvoiceProfileState {
    selectedView: string;
}

const initialState: ProviderInvoiceProfileState = {
    selectedView: 'info',
};

const providerInvoiceProfileSlice = createSlice({
    name: 'providerInvoiceProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = providerInvoiceProfileSlice.actions;
export default providerInvoiceProfileSlice.reducer;
